(() => {
  const LOADED_ATTR = 'data-mm-loaded';

  function hydrate(detailsEl) {
    if (!detailsEl || detailsEl.hasAttribute(LOADED_ATTR)) return;

    // Find placeholder and template within this <details>
    const host = detailsEl.querySelector('[data-mm-placeholder]');
    // Template id uses the forloop.index baked into Details-HeaderMenu-<index>
    const id = detailsEl.id && detailsEl.id.replace('Details-HeaderMenu-', '');
    const tpl = id ? detailsEl.querySelector(`#MM-Tpl-${id}`) : detailsEl.querySelector('[data-mm-template]');

    if (!host || !tpl) return;

    host.setAttribute('aria-busy', 'true');
    host.appendChild(tpl.content.cloneNode(true));
    detailsEl.setAttribute(LOADED_ATTR, 'true');
    host.setAttribute('aria-busy', 'false');
  }

  // Hydrate when a details opens (click/keyboard)
  document.addEventListener('toggle', (e) => {
    const el = e.target;
    if (el && el.tagName === 'DETAILS' && el.classList.contains('mega-menu') && el.open) {
      hydrate(el);
    }
  }, true);

  // Optional: pre-hydrate on hover/focus for instant open
  function maybeHydrateFromSummary(ev) {
    const summary = ev.target.closest('summary');
    if (!summary) return;
    const detailsEl = summary.closest('details.mega-menu');
    if (detailsEl) hydrate(detailsEl);
  }

  document.addEventListener('mouseenter', maybeHydrateFromSummary, true);
  document.addEventListener('focusin', maybeHydrateFromSummary, true);
})();
